import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import AirNoticeCarousel from '../../../common/components/AirNoticeCarousel';
import { BellIcon, PhoneIcon } from '../../../common/icons';
import NoticeDetail from './NoticeDetail';
import isEqual from 'lodash/isEqual';

import { withRouter } from 'react-router-dom';

@withRouter
@inject('translationsStore', 'carsStore', 'noticesStore')
@observer
export default class NoticesLoader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingNotices: false,
      noticeItems: [],
      noticeSelectedIndex: 0
    };
  }

  componentDidMount = () => {
    const { noticesStore } = this.props;
    !noticesStore.carouselVisible &&
      this.setupNotices(() => {
        noticesStore.carouselVisible = true;
      });
    if (this.props.notices.length > 0 && !noticesStore.carouselVisible) {
      this.setupNotices(() => {
        noticesStore.carouselVisible = true;
      });
    }
  };

  componentDidUpdate = prevProps => {
    const { noticesStore } = this.props;
    if (!isEqual(this.props.notices, prevProps.notices) && !noticesStore.carouselVisible) {
      this.setupNotices(() => {
        noticesStore.carouselVisible = true;
      });
    }
  };

  carouselOnChange = (selectedIndex, prevSelectedIndex) => {
    this.setState({ noticeSelectedIndex: selectedIndex });
  };

  carouselOnCancel = lastSelectedIndex => {
    const { noticesStore } = this.props;

    noticesStore.carouselVisible = false;
    this.setupNotices();
  };

  carouselOnDetailShow = data => {
    typeof data !== 'undefined' && this.setItemAsViewed(data);
  };

  carouselGoToVehicleDetail = data => {
    const { noticesStore } = this.props;
    this.setItemAsDismissed(data);
    noticesStore.carouselVisible = false;
    this.setupNotices();

    const { history } = this.props;
    window.goToCarView(null,data.carId);
    if (data.type === 'fuel-theft') {
      history.push(`/dashboard/${data.carId}?tab=focus&modal=fuel`);
    } else if (data.type === 'rpm-over') {
      history.push(`/dashboard/${data.carId}?tab=focus&modal=rpm`);
    } else if (data.type === 'geofenceInside' || (data.type === 'geofenceOutside')) {
      history.push(`/dashboard/${data.carId}?tab=focus`);
    } else {
      history.push(`/dashboard/${data.carId}?tab=notice`);
    }
  };

  setItemAsDismissed = key => {
    const { noticesStore } = this.props;
    noticesStore.setMultipleDismissedSamePlateType(key);
  };

  setItemAsViewed = key => {
    const { noticesStore } = this.props;
    noticesStore.setViewed(key);
  };

  setupNotices = (onDone = () => {}) => {
    let { noticesStore } = this.props;
    let notices = noticesStore.unreadFirstNotices;
    if (notices.length > 0) {
      this.setState(
        {
          noticeItems: notices,
          noticeSelectedIndex: 0
        },
        onDone
      );
    }
  };

  carouselOnPageChange = (page) => {
    const { noticesStore } = this.props;
    return noticesStore.loadNoticesVirtual({ page });
  };

  render() {
    const { translationsStore, noticesStore } = this.props;
    const notices = noticesStore.virtualNotices;
    return (
      <AirNoticeCarousel
        visible={noticesStore.carouselVisible}
        items={notices}
        selectedIndex={this.state.noticeSelectedIndex}
        onChange={this.carouselOnChange}
        onCancel={this.carouselOnCancel}
        onPageChange={this.carouselOnPageChange}
        total={noticesStore.noticesCount}
        width={820}
        height={540}
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexGrow: 1 }}>
            <BellIcon width="13px" height="15px" />
            <div style={{ marginLeft: 12, textTransform: 'uppercase' }}>{translationsStore.translate('notices.modalCarousel.warnings')}</div>
            <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
              <div style={{ marginRight: 8, height: '30px', lineHeight: '30px' }}>{translationsStore.translate('notices.modalCarousel.operationsCenter')}</div>
              <div
                style={{
                  backgroundColor: '#ffffff',
                  color: 'var(--red-dtc-color)',
                  height: '30px',
                  lineHeight: '30px',
                  fontSize: '18px',
                  borderRadius: 15,
                  padding: '0 15px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <PhoneIcon />
                {translationsStore.translate('notices.modalCarousel.operationsCenterPhone')}
              </div>
            </div>
          </div>
        }
        titleBarStyle={{ backgroundColor: 'var(--red-dtc-color)' }}
        renderDetail={data => <NoticeDetail data={data} onDetailShow={() => this.carouselOnDetailShow(data)} onGoToDetail={() => this.carouselGoToVehicleDetail(data)} />}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/NoticesLoader/NoticesLoader.js